class API {
  constructor() {
    this.url =
      "https://script.google.com/macros/s/AKfycbwRahLq7Rg7uhnRUYSdv9KfK_rsRy78jcdbASD4f9F6yAvmeA27HN1fL24e28Luzgxj/exec";
  }

  async push(feedbackData) {
    const data = JSON.stringify(feedbackData);

    return fetch(this.url, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    });
  }
}

export default API;
